import { useMutation, useQueryClient } from '@tanstack/react-query';

import { apiClient } from 'src/api';
import { useAtlassianUser } from 'src/hooks/useAtlassianUser';

import { LEARNING_OBJECT_QUERY_KEY } from './useGetLearningObjectsById';

interface EnrollInSessionVariables {
  courseId: string;
  sessionId: string;
}

export const useEnrollInSession = () => {
  const { user } = useAtlassianUser();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ courseId, sessionId }: EnrollInSessionVariables) => {
      if (!user?.email || !user.account_id) {
        throw new Error('User information is required to enroll in a session.');
      }

      const strippedCourseId = courseId.replace(/^course:/, '');
      const sessionSuffix = sessionId.includes('_') ? sessionId : `${strippedCourseId}_${sessionId}`;
      const loInstanceId = sessionId.startsWith('course:') ? sessionId : `course:${sessionSuffix}`;

      return apiClient.adobe.createEnrollment({
        email: user.email,
        aaid: user.account_id,
        loId: courseId,
        loInstanceId,
      });
    },
    onSuccess: async (_data, { courseId }) => {
      await queryClient.invalidateQueries({
        queryKey: [LEARNING_OBJECT_QUERY_KEY, courseId, user?.account_id],
      });
    },
  });
};
